import { ChartTimeSeriesLineTheme } from '@hcs/design-system';
import { DateStr } from '@hcs/types';

import { CerberusStatsRpiChart } from '../../components/CerberusStatsRpiChart';
import { MACRO_INSIGHTS_FROM_DATE } from '../../constants/marketInsights.constants';
import { useZipRpiTimeSeries } from '../../hooks/useZipRpiTimeSeries';

const dataHcName = 'zip-rpi-chart';

interface ZipHpiChartProps {
  className?: string;
  zipcode: string;
  fromDate?: DateStr;
  toDate?: DateStr;
  theme?: Partial<ChartTimeSeriesLineTheme>;
}
export const ZipRpiChart = ({
  zipcode,
  className,
  fromDate = MACRO_INSIGHTS_FROM_DATE,
  toDate,
  theme,
}: ZipHpiChartProps) => {
  const { data, isLoading } = useZipRpiTimeSeries({
    zipcode,
    fromDate,
    toDate,
  });
  return (
    <CerberusStatsRpiChart
      dataHcName={dataHcName}
      className={className}
      data={data}
      theme={theme}
      isLoading={isLoading}
    />
  );
};
